import React, { useEffect, useState } from 'react';
import { userGrantGroupPermissions } from '../../api/actions/user/user-grant-group-permissions';
import { Loader } from '../../components/loader/loader';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { PublicPage } from '../base/public-page';
import { MainLayout } from '../../components/layouts/main-layout';
import { LoginComponent } from '../login/login-component';
import { SignUpComponent } from '../signup/signup-component';
import { AppConfig } from '../../config/app-config';
import { MultiError } from '../../types/multi-error';
import { openExtensionUrl } from '../../helpers/common-helpers';

export function GrantPermissionsPage() {

    const [user_uid] = useState((new URL(window.location.href)).searchParams.get('user') || undefined);
    const [group_uid] = useState((new URL(window.location.href)).searchParams.get('group') || undefined);

    const history = useHistory();

    const [loading, setLoading] = useState<string | undefined>('Please wait, processing...');
    const [error, setError] = useState<string | undefined>();

    const [email, setEmail] = useState<string | undefined>();
    const [signUpVisible, setSignUpVisible] = useState(false);
    const [loginVisible, setLoginVisible] = useState(false);

    useEffect(() => {
        grantPermissions();
    }, []);

    const grantPermissions = async () => {

        const url = '/analytics';

        setSignUpVisible(false);
        setLoginVisible(false);

        if(!user_uid || !group_uid) {
            setLoading(undefined);
            setError('Invalid user or group');
            return;
        }


        try {
            const result = await userGrantGroupPermissions(user_uid, group_uid);

            if(result.success) {
                const message = result.already_granted ? 'You have already granted permissions to this user' : 'Permissions successfully granted'
                toast.success(message);
                history.push(url);
            }
            if(result.invalid_user_or_group) {
                const errMessage = 'Invalid user or group'
                setError(errMessage);
                toast.error(`ERROR: ${errMessage}`);
            }
            else if(result.not_logged_in) {
                setLoginVisible(true);
            }
            else {
                setError('Unknown error');
            }
        }
        catch(err) {
            setError((err as MultiError).message);
            toast.error(`ERROR: ${(err as MultiError).message}`);
        }

        setLoading(undefined);
    }

    return loading ? (<Loader text={loading} />) : (<>
        <PublicPage pageName="invite_page">
            <MainLayout>
                <>
                    {error && (<div className="errors">{error}</div>)}

                    {loginVisible && (
                        <LoginComponent onSuccessLogin={grantPermissions} />
                    )}

                </>
            </MainLayout>
        </PublicPage>
    </>);
}
